/** 商品規格價格欄位設定（順序即畫面順序） */
export const PRICE_FIELDS = [
    { field: 'originalPrice', label: '售價', required: true, tip: '店舖販售的原始價格。' },
    { field: 'costPrice', label: '成本', required: true, tip: '商品的進貨成本，用於毛利計算，不會顯示給會員。' },
    { field: 'salePrice', label: '會員價', required: true, tip: '結帳時主要使用的價格。' },
    { field: 'memberPrice', label: '定價', required: true, tip: '顯示在結帳畫面（POS）與新增收入畫面的價格。' },
    { field: 'discountPrice', label: '折扣價', required: false, tip: '定義待確認。', isHighlight: true },
];
